module.exports = __webpack_public_path__ + "static/media/icon-status-paperwork.78b48216.svg";